import React from "react";

const Benefits = () => {
  return (
    <section id="benefits">
      <header className="benefits-head">
        <h2>The Perfect Travelling Experience With Tripoto</h2>
        <div className="benefit-card-container">
          <div className="benefit-card">
            <img src="./Assets/benefits-img/1.jpg" alt="" />
            <div className="benefit-content">
              <h5>Lorem ipsum.</h5>
              <p>Lorem ipsum dolor sit amet, elit.</p>
            </div>
          </div>
          <div className="benefit-card">
            <img src="./Assets/benefits-img/1.jpg" alt="" />
            <div className="benefit-content">
              <h5>Lorem ipsum.</h5>
              <p>Lorem ipsum dolor sit amet, elit.</p>
            </div>
          </div>
          <div className="benefit-card">
            <img src="./Assets/benefits-img/1.jpg" alt="" />
            <div className="benefit-content">
              <h5>Lorem ipsum.</h5>
              <p>Lorem ipsum dolor sit amet, elit.</p>
            </div>
          </div>
          <div className="benefit-card">
            <img src="./Assets/benefits-img/1.jpg" alt="" />
            <div className="benefit-content">
              <h5>Lorem ipsum.</h5>
              <p>Lorem ipsum dolor sit amet, elit.</p>
            </div>
          </div>
        </div>
      </header>
    </section>
  );
};

export default Benefits;
